/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Technical_SpecInputs */

const en_doc_type_technical_spec = /** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Specification`)
};

const id_doc_type_technical_spec = /** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasi Teknis`)
};

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const es_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const fr_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const de_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const ja_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const zh_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const ar_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const it_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const ru_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const pt_doc_type_technical_spec = en_doc_type_technical_spec;

/** @type {(inputs: Doc_Type_Technical_SpecInputs) => LocalizedString} */
const ko_doc_type_technical_spec = en_doc_type_technical_spec;

/**
* | output |
* | --- |
* | "Technical Specification" |
*
* @param {Doc_Type_Technical_SpecInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_technical_spec = /** @type {((inputs?: Doc_Type_Technical_SpecInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Technical_SpecInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_technical_spec(inputs)
	if (locale === "es") return es_doc_type_technical_spec(inputs)
	if (locale === "fr") return fr_doc_type_technical_spec(inputs)
	if (locale === "de") return de_doc_type_technical_spec(inputs)
	if (locale === "ja") return ja_doc_type_technical_spec(inputs)
	if (locale === "zh") return zh_doc_type_technical_spec(inputs)
	if (locale === "ar") return ar_doc_type_technical_spec(inputs)
	if (locale === "id") return id_doc_type_technical_spec(inputs)
	if (locale === "it") return it_doc_type_technical_spec(inputs)
	if (locale === "ru") return ru_doc_type_technical_spec(inputs)
	if (locale === "pt") return pt_doc_type_technical_spec(inputs)
	return ko_doc_type_technical_spec(inputs)
});